(()=>{const toggle=document.querySelector('.kc-menu-toggle'),nav=document.querySelector('#kc-mobile-nav');if(toggle&&nav){const set=open=>{nav.hidden=!open;toggle.setAttribute('aria-expanded',String(open));toggle.setAttribute('aria-label',open?'Close menu':'Open menu');};toggle.addEventListener('click',()=>set(nav.hidden));document.addEventListener('keydown',e=>{if(e.key==='Escape'&&!nav.hidden){set(false);toggle.focus();}});nav.querySelectorAll('a').forEach(a=>a.addEventListener('click',()=>set(false)));}document.querySelectorAll('.kc-category').forEach(s=>s.addEventListener('change',()=>{location.href=s.value;}));document.querySelectorAll('.kc-sort').forEach(s=>s.addEventListener('change',()=>{const u=new URL(location.href);u.searchParams.set('sort_by',s.value);u.searchParams.delete('page');u.hash='catalog';location.href=u;}));})();
// Scroll-driven hero parallax: the center jersey travels fastest.
(()=>{
 const reduced=window.matchMedia('(prefers-reduced-motion: reduce)');
 const phone=window.matchMedia('(max-width: 749px)');
 let heroes=[],frame=0;
 const paint=()=>{
  frame=0;
  heroes.forEach(hero=>{
   const rect=hero.getBoundingClientRect();
   const distance=reduced.matches?0:Math.max(0,Math.min(window.scrollY,rect.height+rect.top+window.scrollY))*.2;
   const vertical=phone.matches?[-.25,-.5,-.2]:[1/64,1/32,1/64];
   const rotation=phone.matches?[-1/25,1/20,1/30]:[-1/25,1/40,1/25];
   hero.querySelectorAll('.kc-hero-kit').forEach((kit,index)=>{
    kit.style.setProperty('--kc-parallax-y',`${(distance*vertical[index]).toFixed(2)}px`);
    kit.style.setProperty('--kc-parallax-rotate',`${(distance*rotation[index]).toFixed(2)}deg`);
   });
  });
 };
 const schedule=()=>{if(!frame)frame=window.requestAnimationFrame(paint);};
 const refresh=()=>{heroes=[...document.querySelectorAll('.kc-hero')];schedule();};
 window.addEventListener('scroll',schedule,{passive:true});
 window.addEventListener('resize',schedule,{passive:true});
 window.addEventListener('pageshow',refresh);
 reduced.addEventListener('change',schedule);
 document.addEventListener('shopify:section:load',refresh);
 refresh();
})();
